import React, { useState, useEffect } from 'react';
import PlanTableMobile from './PlanTableMobile';
import PlanTableDesktop from './PlanTableDesktop';
import { defaultAvatar } from '../../constants/constants';
import RecommendedClasses from '../RecommendedClasses';
import { useHistory, useLocation } from 'react-router-dom';
import { scrollToSection } from '../../generalFunction';

interface PlansTableProps {
  conciergeData: {
    avatar_url: string;
    email: string;
    first_name: string;
    phone_number: string;
  };
  plan: any;
  recomendedGroupClasses: any;
  studentFirstName: string;
}

const PlansTable: React.FC<PlansTableProps> = ({
  conciergeData = {} as PlansTableProps['conciergeData'],
  plan,
  recomendedGroupClasses,
  studentFirstName
}) => {
  const history = useHistory();
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const conciergeAvatar = conciergeData.avatar_url || defaultAvatar;

  //   const businessPhoneNumber = getBusinessPhoneNumber();
  const businessPhoneNumber = '+1 (855) 771-2929';

  // Check for plan UUID in query string on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const planUuidFromUrl = urlParams.get('plan_uuid');
    if (planUuidFromUrl && plan && plan.length > 0 && !hasScrolled) {
      setTimeout(() => {
        scrollToSection('plans-table', 0);
        setHasScrolled(true);
      }, 200);

      // Remove plan_uuid from query parameters after scrolling
      urlParams.delete('plan_uuid');
      const newUrl = `${location.pathname}${urlParams.toString() ? '?' + urlParams.toString() : ''}`;
      history.replace(newUrl);
    }
  }, [location.search, plan, hasScrolled]);

  const handleMore = () => {
    setShowMore(!showMore);
  };

  return (
    <>
      <section
        id="plans-table"
        className="font-monaSans w-full max-w-[1100px] flex items-center justify-center flex-col mt-[40px] md:mt-[100px] md:px-[25px] lg:px-0"
      >
        <h3 className="font-monaSans text-[24px] md:text-[36px] font-semibold leading-[26px]">
          Plans curated for {studentFirstName || 'student'}
        </h3>
        <div className="flex items-center justify-center gap-[10px] mb-[24px] mt-[10px] md:mt-[8px]">
          <p className="text-[#868686] text-[14px] md:text-[15px] font-medium leading-[20px]">
            From your advisor
          </p>
          <div className="relative flex items-center cursor-pointer" onClick={handleMore}>
            <img
              className="w-[20px] h-[20px] md:w-[24px] md:h-[24px]"
              height="24"
              width="24"
              src={conciergeAvatar}
              alt="concierge-avatar"
            />
            <p className="text-[14px] font-medium leading-[20px] text-[#000] ml-[10px] md:ml-[8px]">
              {conciergeData.first_name}
            </p>
          </div>
        </div>
        <div className="lg:w-auto px-[25px] md:px-0 w-full ">
          <div className="lg:hidden w-full">
            <PlanTableMobile planData={plan} />
          </div>
          <div className="hidden lg:flex items-center justify-center">
            <PlanTableDesktop planData={plan} />
          </div>
          {recomendedGroupClasses && recomendedGroupClasses?.length > 0 && (
            <div className="mt-[50px] md:mt-[40px] w-full">
              <RecommendedClasses recomendedGroupClasses={recomendedGroupClasses} />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default PlansTable;
